import { Region, trackingService } from '@monthio/react-components'

const showIntercom = () => window.Intercom?.('show')
const startSurveyIntercom = (surveyId: number) =>
	window.Intercom?.('startSurvey', surveyId)
const updateIntercom = (additionalData: Record<string, string>) =>
	window.Intercom?.('update', additionalData)
const trackEvent = (eventName: string, additionalData?: any) =>
	window.Intercom?.('trackEvent', eventName, additionalData)

class IntercomService {
	private initialized = false
	private endOfFlowSurveyTriggered = false
	private readonly initializeQueue: (() => void)[] = []
	public readonly initialize = () => {
		if (this.initialized) {
			return
		}

		trackingService.events.subscribe((event) => {
			this.trackEvent(event.eventName, event.additional)
		})
		this.initializeQueue.forEach((fn) => fn())

		this.initialized = true
	}

	private readonly trackEvent = trackEvent
	private readonly update = updateIntercom
	private readonly startSurvey = startSurveyIntercom

	public readonly setOpenReplayUrls = (openReplayUrl?: string) => {
		const openReplay = { openreplay_session_url: openReplayUrl ?? '' }
		if (!this.initialized) {
			this.initializeQueue.push(() => {
				this.update(openReplay)
			})
			return
		}

		this.update(openReplay)
	}

	public readonly show = showIntercom

	public readonly startEndOfFlowSurvey = (regionId?: Region) => {
		if (!this.endOfFlowSurveyTriggered) {
			switch (regionId) {
				case Region.Denmark:
					this.startSurvey(35569293)
			}
			this.endOfFlowSurveyTriggered = true
		}
	}
}

export const intercomService = new IntercomService()
